(() => {
  const drawer = document.querySelector('[data-paw-cart]');
  const root = drawer?.dataset.root || '/';
  const endpoint = path => `${root.replace(/\/?$/, '/')}${path}`;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: drawer?.dataset.currency || 'USD' }).format(cents / 100);
  let cartBusy = false, returnFocus;
  const addonKinds = new Set(['protection', 'priority']);
  const addonInputs = purchase => [...purchase.querySelectorAll('[data-addon-variant]')];
  function selectedAddons(purchase) {
    const selected = purchase.querySelector('[data-quantity-offer][data-selected]') || purchase;
    const variants = new Set(), kinds = new Set();
    return [...selected.querySelectorAll('[data-addon-variant]')].filter(input => {
      const id = input.dataset.addonVariant, kind = input.dataset.addonKind;
      if (!input.checked || input.disabled || !/^\d+$/.test(id || '') || !addonKinds.has(kind) || variants.has(id) || kinds.has(kind)) return false;
      variants.add(id); kinds.add(kind); return true;
    });
  }
  function updateAddonTotals(purchase) {
    const quantity = Number(purchase.querySelector('[data-quantity]')?.value || 1);
    const base = typeof purchase.totalCents === 'function' ? purchase.totalCents(quantity) : 0;
    const addonCents = selectedAddons(purchase).reduce((sum, input) => sum + Math.max(0, Number(input.dataset.price) || 0), 0);
    purchase.querySelectorAll('[data-addon-total]').forEach(node => { node.textContent = money(addonCents); });
    purchase.querySelectorAll('[data-bundle-purchase-total]').forEach(node => { node.textContent = money(base + addonCents); });
    purchase.querySelectorAll('[data-addon-summary]').forEach(node => { node.hidden = addonCents === 0; });
    const sticky = purchase.closest('.product-section')?.querySelector('[data-sticky-price]');
    if (sticky && typeof purchase.totalCents === 'function') sticky.textContent = money(base + addonCents);
    purchase.querySelectorAll('[data-dynamic-checkout]').forEach(node => { node.hidden = addonCents > 0 || purchase.querySelector('[data-variant-select]')?.selectedOptions[0]?.dataset.available !== 'true'; });
    document.dispatchEvent(new CustomEvent('loves-aura:addons-changed', { detail: { purchase, totalCents: base + addonCents, addonCents } }));
  }
  function managedAddon(item) {
    return addonKinds.has(item.properties?._loves_aura_addon) || [...document.querySelectorAll('[data-addon-variant]')].some(input => input.dataset.addonVariant === String(item.variant_id || item.id));
  }
  document.addEventListener('change', event => {
    const purchase = event.target.closest('product-purchase');
    if (!purchase) return;
    const input = event.target.closest('[data-addon-variant]');
    if (input?.disabled) { input.checked = false; return; }
    if (input) addonInputs(purchase).forEach(other => { if (other.dataset.addonKind === input.dataset.addonKind) other.checked = !input.disabled && !other.disabled && input.checked; });
    if (input || event.target.matches('[data-quantity], [data-variant-select]')) requestAnimationFrame(() => updateAddonTotals(purchase));
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-quantity]')) requestAnimationFrame(() => updateAddonTotals(event.target.closest('product-purchase')));
  });
  document.querySelectorAll('product-purchase').forEach(purchase => {
    if (!drawer || typeof fetch !== 'function') addonInputs(purchase).forEach(input => { input.disabled = true; input.checked = false; });
    updateAddonTotals(purchase);
  });
  function text(tag, value, className) {
    const node = document.createElement(tag); node.textContent = value ?? ''; if (className) node.className = className; return node;
  }
  function cartError(message) {
    const node = drawer.querySelector('[data-paw-cart-error]'); node.textContent = message; node.hidden = !message;
  }
  function renderCart(cart) {
    const lines = drawer.querySelector('[data-paw-cart-lines]'); lines.replaceChildren();
    drawer.querySelector('[data-paw-cart-empty]').hidden = cart.item_count > 0;
    drawer.querySelector('[data-paw-cart-footer]').hidden = cart.item_count === 0;
    drawer.querySelector('[data-paw-cart-count]').textContent = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; node.hidden = !cart.item_count; });
    drawer.querySelector('[data-paw-cart-total]').textContent = money(cart.total_price || 0);
    const saving = drawer.querySelector('[data-paw-cart-discounts]'); saving.hidden = !cart.total_discount; saving.textContent = cart.total_discount ? `${drawer.dataset.savingsLabel} ${money(cart.total_discount)}` : '';
    for (const item of cart.items || []) {
      const row = document.createElement('article'); row.className = 'paw-cart-line';
      const image = new Image(); image.alt = item.product_title || item.title; image.width = 100; image.height = 100;
      const src = String(item.variant_id || item.id) === drawer.dataset.orbVariant ? drawer.dataset.orbImage : item.image;
      if (src) { const imageURL = new URL(src, location.origin); if (['https:', 'http:'].includes(imageURL.protocol)) image.src = imageURL.href; }
      const info = document.createElement('div'); info.append(text('h3', item.product_title || item.title));
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(text('p', item.variant_title));
      const price = text('p', '', 'paw-cart-line-price');
      if (item.original_line_price > item.final_line_price) price.append(text('s', money(item.original_line_price)));
      price.append(text('strong', money(item.final_line_price ?? item.line_price))); info.append(price);
      const controls = document.createElement('div'); controls.className = 'paw-cart-line-controls';
      const actions = managedAddon(item) ? [[0, drawer.dataset.removeLabel]] : [[-1, drawer.dataset.decreaseLabel], [0, drawer.dataset.removeLabel], [1, drawer.dataset.increaseLabel]];
      for (const [action, label] of actions) {
        const button = text('button', action === 0 ? label : action < 0 ? '−' : '+'); button.type = 'button'; button.dataset.pawCartKey = item.key; button.dataset.pawCartQuantity = String(action === 0 ? 0 : item.quantity + action); button.setAttribute('aria-label', `${label}: ${item.product_title || item.title}`);
        if (action === 0) { button.className = 'paw-cart-remove'; controls.append(text('span', String(item.quantity), 'paw-cart-line-quantity')); }
        controls.append(button);
      }
      info.append(controls); row.append(image, info); lines.append(row);
    }
    document.dispatchEvent(new CustomEvent('loves-aura:cart-updated', { detail: { items: (cart.items || []).map(item => ({ variant_id: item.variant_id, quantity: item.quantity, price: item.price ?? item.original_price })) } }));
  }
  async function requestCart(path = 'cart.js', options) {
    const response = await fetch(endpoint(path), { credentials: 'same-origin', headers: { Accept: 'application/json', ...options?.headers }, ...options });
    const data = await response.json(); if (!response.ok) throw new Error(data.description || data.message || drawer.dataset.errorLabel);
    return path !== 'cart/add.js' && Array.isArray(data.items) && window.lovesAuraGift?.reconcile ? window.lovesAuraGift.reconcile(data) : data;
  }
  function showCart(trigger) {
    returnFocus = trigger; document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; });
    if (!drawer.open) drawer.showModal(); drawer.querySelector('header button').focus({ preventScroll: true });
    if (typeof syncStickyPurchase === 'function') syncStickyPurchase();
  }
  document.addEventListener('click', async event => {
    const details = event.target.closest('[data-paw-details-open]');
    if (details) { const dialog = details.closest('.paw-product').querySelector('[data-paw-details-dialog]'); dialog.pawReturnFocus = details; dialog.showModal(); }
    const open = event.target.closest('[data-cart-open]');
    if (open && drawer && typeof fetch === 'function') {
      event.preventDefault(); showCart(open); cartError(''); drawer.setAttribute('aria-busy', 'true');
      try { renderCart(await requestCart()); } catch { cartError(drawer.dataset.errorLabel); drawer.querySelector('[data-paw-cart-footer]').hidden = false; } finally { drawer.removeAttribute('aria-busy'); }
    }
    const change = event.target.closest('[data-paw-cart-key]');
    if (change && !cartBusy) {
      cartBusy = true; drawer.setAttribute('aria-busy', 'true'); drawer.querySelectorAll('[data-paw-cart-key]').forEach(node => { node.disabled = true; }); cartError('');
      try { renderCart(await requestCart('cart/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: change.dataset.pawCartKey, quantity: Number(change.dataset.pawCartQuantity) }) })); }
      catch (error) { cartError(error.message); drawer.querySelectorAll('[data-paw-cart-key]').forEach(node => { node.disabled = false; }); }
      finally { cartBusy = false; drawer.removeAttribute('aria-busy'); drawer.querySelector('header button').focus({ preventScroll: true }); }
    }
    const idea = event.target.closest('[data-paw-idea-index]');
    if (idea) { const rail = idea.closest('[data-paw-gift-idea]').querySelector('[data-paw-idea-track]'); rail.scrollTo({ left: rail.clientWidth * Number(idea.dataset.pawIdeaIndex), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
    if (event.target.matches('.paw-cart-drawer, .paw-details-dialog')) event.target.close();
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.paw-product product-purchase form');
    if (!form || !drawer || typeof fetch !== 'function') return;
    const button = form.querySelector('[data-add]'); if (!button) return;
    if (button.disabled || cartBusy) { event.preventDefault(); return; }
    event.preventDefault(); const error = form.querySelector('[data-paw-add-error]'); error.hidden = true; button.disabled = true; button.setAttribute('aria-busy', 'true');
    cartBusy = true;
    const data = new FormData(form), fields = new URLSearchParams(); for (const [key, value] of data) if (typeof value === 'string') fields.append(key, value);
    try {
      const addons = selectedAddons(form.closest('product-purchase'));
      if (addons.length) {
        const cart = await requestCart(), existing = new Set((cart.items || []).filter(item => item.quantity > 0).map(item => String(item.variant_id || item.id)));
        const orb = { id: data.get('id'), quantity: Number(data.get('quantity') || 1) };
        const properties = {};
        for (const [key, value] of data) { const match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value; }
        if (Object.keys(properties).length) orb.properties = properties;
        if (data.get('selling_plan')) orb.selling_plan = data.get('selling_plan');
        const items = [orb, ...addons.filter(input => !existing.has(input.dataset.addonVariant)).map(input => ({ id: input.dataset.addonVariant, quantity: 1, properties: { _loves_aura_addon: input.dataset.addonKind, _loves_aura_parent: String(orb.id) } }))];
        await requestCart('cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      } else await requestCart('cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' }, body: fields });
      showCart(button); renderCart(await requestCart()); cartError('');
    }
    catch (failure) {
      try { const current = await requestCart(); if (current.item_count > 0) { showCart(button); renderCart(current); } } catch {}
      if (drawer.open) { cartError(failure.message || drawer.dataset.errorLabel); drawer.querySelector('[data-paw-cart-footer]').hidden = false; }
      error.textContent = `${failure.message || drawer.dataset.errorLabel} ${drawer.dataset.errorLabel}`; error.hidden = false;
    }
    finally { cartBusy = false; button.removeAttribute('aria-busy'); button.disabled = form.closest('product-purchase').querySelector('[data-variant-select]').selectedOptions[0]?.dataset.available !== 'true'; }
  });
  document.addEventListener('close', event => {
    if (event.target === drawer) returnFocus?.focus({ preventScroll: true });
    if (event.target.matches('[data-paw-details-dialog]')) event.target.pawReturnFocus?.focus({ preventScroll: true });
  }, true);
  document.querySelectorAll('[data-paw-idea-track]').forEach(rail => rail.addEventListener('scroll', () => {
    const index = Math.round(rail.scrollLeft / rail.clientWidth); rail.closest('[data-paw-gift-idea]').querySelectorAll('[data-paw-idea-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.pawIdeaIndex) === index)));
  }, { passive: true }));
  document.querySelectorAll('.paw-product [data-gallery]').forEach(gallery => {
    const viewport = gallery.querySelector('.product-gallery__main');
    if (!viewport) return;
    const mobile = matchMedia('(max-width:749px)');
    let timer, lastWidth = 0, wasMobile = false;
    function syncSelection() {
      clearTimeout(timer);
      if (!mobile.matches) return;
      if (!wasMobile || viewport.clientWidth !== lastWidth) {
        alignAfterResize();
        return;
      }
      const slides = [...gallery.querySelectorAll('[data-media-id]')];
      const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const selected = slides.reduce((nearest, slide) => {
        const distance = Math.abs(Math.min(slide.offsetLeft, maximum) - viewport.scrollLeft);
        return !nearest || distance < nearest.distance ? { slide, distance } : nearest;
      }, null)?.slide;
      if (selected?.hidden) activateMedia(gallery, selected.dataset.mediaId, { scroll: false });
    }
    viewport.addEventListener('scroll', () => {
      clearTimeout(timer);
      if (mobile.matches) timer = setTimeout(syncSelection, 140);
    }, { passive: true });
    viewport.addEventListener('scrollend', syncSelection);
    function alignAfterResize() {
      const width = viewport.clientWidth;
      if (mobile.matches && (!wasMobile || width !== lastWidth)) {
        clearTimeout(timer);
        const selected = gallery.querySelector('[data-media-id]:not([hidden])');
        if (selected) activateMedia(gallery, selected.dataset.mediaId, { behavior: 'instant' });
      }
      lastWidth = width; wasMobile = mobile.matches;
    }
    if ('ResizeObserver' in window) new ResizeObserver(alignAfterResize).observe(viewport);
    else window.addEventListener('resize', alignAfterResize);
    alignAfterResize();
    viewport.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        gallery.querySelector(`[data-gallery-step="${event.key === 'ArrowRight' ? 1 : -1}"]`)?.click();
      }
    });
  });
})();
